import { Dialog, DialogContent } from '@mui/material';
import Text from '../../../components/Text';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import Button from '../../../components/Button';
import Divider from '../../../components/Divider';
import CustomCheckbox from '../../../components/CustomCheckbox';
import { useSelector } from 'react-redux';
import { cn, getContentKeyAccToLang } from '../../../utils/utils';
import ViewReverse from '../../../components/ViewReverse';

const SuitabilityModal = ({ open, onPressOkay, toogleAgree, agree, getContent }) => {
  const { TextWeight, isArabic } = dynamicfunction();

  const { fundsContent } = useSelector((state) => state.content);
  const { suitability_status, suitability_data } = useSelector((state) => state.fund);


  const getContentKey = (key) => {
    return getContentKeyAccToLang(fundsContent?.web_suitability?.data?.attributes, key, isArabic);
  };

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: '12px',
        },
      }}
      maxWidth={'lg'}
    >
      <DialogContent className='sm:min-w-[22rem] rounded-lg'>
        <Text text={getContentKey('suitability_report')} size={fontSizes.h18} weight={TextWeight.bold} />

        <Text text={getContent(suitability_status)} size={fontSizes.h18} weight={TextWeight.bold} className={'mt-4'} />

        <Text text={getContentKey('suitability_note')} color='text-silver' size={fontSizes.h14} isTruncate={false} className={'mt-4'} />

        <ul dir={isArabic ? 'rtl' : 'ltr'} className='list-disc my-4 ps-4'>
          <li>
            <Text
              text={
                <>
                  {getContentKey('investment_objectives')}{' '}
                  <Text
                    text={getContentKey('investment_objective_note')}
                    color='text-silver'
                    size={fontSizes.h14}
                    className={'inline'}
                    isTruncate={false}
                  />
                </>
              }
              size={fontSizes.h14}
              weight={TextWeight.medium}
              isTruncate={false}
            />
          </li>
          <li>
            <Text
              text={
                <>
                  {getContentKey('risk_tolerance')}{' '}
                  <Text
                    text={getContentKey('risk_tolerance_note')}
                    color='text-silver'
                    size={fontSizes.h14}
                    className={'inline'}
                    isTruncate={false}
                  />
                </>
              }
              size={fontSizes.h14}
              weight={TextWeight.medium}
              isTruncate={false}
            />
          </li>
          <li>
            <Text
              text={
                <>
                  {getContentKey('fund_risks')}{' '}
                  <Text text={getContentKey('fund_risks_note')} color='text-silver' size={fontSizes.h14} className={'inline'} isTruncate={false} />
                </>
              }
              size={fontSizes.h14}
              weight={TextWeight.medium}
              isTruncate={false}
            />
          </li>
        </ul>

        <Text
          text={`${getContentKey('suitable_instruction')} ( ${getContent(suitability_status)} ) ${getContentKey('to_subscribe_fund')}`}
          color='text-silver'
          size={fontSizes.h14}
          isTruncate={false}
        />
        {
          !suitability_data?.jsrS_sutabilityFlag && (
            <>
              <CustomCheckbox label={getContentKey('undersigned_and_declare')} isChecked={agree} onClick={toogleAgree} className={'mt-6 mb-5'} />
              <Text text={getContentKey('report_info')} color='text-silver' size={fontSizes.h14} isTruncate={false} />
            </>
          )
        }

        <Divider />
        <ViewReverse>
          <Button text={getContentKey('okay')} isDisabled={!suitability_data?.jsrS_sutabilityFlag && !agree} className={'px-16'} onClick={() => onPressOkay(suitability_data?.jsrS_sutabilityFlag)} />
        </ViewReverse>
      </DialogContent>
    </Dialog>
  );
};

export default SuitabilityModal;
